export default "__VITE_ASSET__De7SWdBC__"